import zod from 'zod';

import type { NumberFormatSchema } from '../number/utils/formatter.js';

export const FORMULA_PROPERTY_TYPE = 'orghub-formula' as const;

/**
 * Config persisted on the column (`column.data`).
 *
 * `expression` stores column references as `{colId}` tokens — the STABLE column
 * id, NOT the display name, so formulas survive column renames. Aggregate
 * functions wrap a token, e.g. `sum({colId}) * 0.1`.
 *
 * NOTE: `FORMULA_PROPERTY_TYPE` and this shape are an on-disk contract. Never
 * rename the type string and only ADD optional fields here.
 */
export type FormulaPropertyData = {
  _v: 1;
  expression: string;
  format: zod.infer<typeof NumberFormatSchema>;
  decimal: number;
  // Display-only affixes wrapped around the formatted number, e.g. `₽`, `kg`,
  // `°C`. Do not affect the computed numeric value (rollup/stats stay numeric).
  prefix?: string;
  suffix?: string;
};

// A string overrides the column formula for one row; null uses the column formula.
export type FormulaRawValue = string | null;

// Fast custom schemas — avoid zod object validation on the data hot-path.
export const FormulaPropertySchema = zod.custom<FormulaPropertyData>(
  v => typeof v === 'object' && v !== null
);
export const FormulaRawValueSchema = zod.custom<FormulaRawValue>(
  v => v === null || typeof v === 'string'
);
